/**
 *
 * Asynchronously loads the component for ZoomSession
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
